/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class CreateLocationData
 */
export class CreateLocationData {
  public name!: string;
  public icon!: string;
  public buildingId!: number;
}
